import { ProfessionalsWorkJourneyOrganization } from 'domain/models';
import { useMemo } from 'react';
import { Badge, Card, CardBody, Collapse } from 'reactstrap';

import { getProfessionalSummary, pluralize } from '../helpers';
import { OrganizationJourneyTable } from '../organization-journey-table';

interface IProps {
  organization: ProfessionalsWorkJourneyOrganization;
  isOpen: boolean;
  onToggle: () => void;
}

export const OrganizationJourneyGroup = ({
  organization,
  isOpen,
  onToggle,
}: IProps) => {
  const professionals = organization.professionals || [];

  const totalDays = useMemo(
    () =>
      professionals.reduce(
        (total, professional) =>
          total + getProfessionalSummary(professional).totalDays,
        0,
      ),
    [professionals],
  );

  return (
    <Card className="border shadow-none mb-3">
      <div
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        onClick={onToggle}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onToggle();
          }
        }}
        className="d-flex align-items-center gap-3 p-3"
      >
        <div className="avatar-sm flex-shrink-0">
          <span className="avatar-title rounded bg-info-subtle text-info fs-20">
            <i className="ri-building-line"></i>
          </span>
        </div>

        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <h5 className="mb-1 fs-15">
            {organization.name || 'Organização não informada'}
          </h5>

          <div className="d-flex align-items-center flex-wrap gap-2">
            <Badge className="bg-info-subtle text-info fw-medium">
              {pluralize(professionals.length, 'profissional', 'profissionais')}
            </Badge>

            <Badge className="bg-body-secondary text-body fw-medium">
              {pluralize(totalDays, 'dia com registro', 'dias com registro')}
            </Badge>
          </div>
        </div>

        <i
          className={`fs-22 text-muted flex-shrink-0 ${
            isOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'
          }`}
        ></i>
      </div>

      <Collapse isOpen={isOpen}>
        <CardBody className="border-top p-0 m-0">
          <OrganizationJourneyTable organization={organization} />
        </CardBody>
      </Collapse>
    </Card>
  );
};
